import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { RootStateType } from '../../redux/features/rootSlice';

const HelmetComponent = () => {
    let clientConfig :any= useSelector(
        (state: RootStateType) => state.configStateReducer.clientConfig
      );
// console.log("clientConfig-fv", clientConfig?.favicon);
const favicon = clientConfig?.favicon 
? `${clientConfig.favicon}?v=${new Date().getTime()}` // Add a query param to bust cache
: '/default-favicon.ico';
// console.log("Favicon URL:", favicon);
  return (
    <>
      <Helmet>
        {/* <title>{clientConfig?.title || 'Default Page Title'}</title> */}
        {/* Example of setting a favicon */}
      <link rel="icon" type="image/x-icon" href={favicon} />
      <link rel="icon" type="image/png" sizes="32x32" href={favicon} />
      <link rel="icon" type="image/png" sizes="16x16" href={favicon} />
      </Helmet>
      {/* Rest of your component */}
    </>
  );
};

export default HelmetComponent;
